import { useState, useEffect } from 'react';

const useForm = (callback, validate) => {

   
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback(values);
      setIsSubmitting(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

//   useEffect(() => {
//   if (Object.keys(errors).length > 0) {
//     const timer = setTimeout(() => {
//       setErrors({});
//     }, 2000);

//     return () => clearTimeout(timer);
//   }
// }, [errors]);

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(values));
    setIsSubmitting(true);
  };

  const handleSubscribe = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(values));
    setIsSubmitting(true);
  };
  
  const handleChange = (event) => {
    event.persist();
    setValues(values => ({ ...values, [event.target.name]: event.target.value }));
  };

  const clearField = () => {
    setValues({});
  }


  return {
    handleChange,
    handleSubmit,
    handleSubscribe,
    clearField,
    values,
    errors,
  }
};

export default useForm;